class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.blockCount == 1) {
      return;
    }

    this.updateAutorotateAvailability();

    if (theme.config.mqlSmall || this.dataset.compact == 'true') {
      this.initSlider();
    }

    document.addEventListener('matchSmall', () => {
      this.unload();
      this.updateAutorotateAvailability();
      this.initSlider();
    });

    document.addEventListener('unmatchSmall', () => {
      this.unload();
      this.updateAutorotateAvailability();

      if (this.dataset.compact === 'true') {
        this.initSlider();
      }
    });
  }

  updateAutorotateAvailability() {
    this.autorotateEnabled = true;
  }

  unload() {
    if (this.flickity && typeof this.flickity.destroy === 'function') {
      this.flickity.destroy();
      this.flickity = null;
      this.resetProgressbar();
      this.removeListeners();
    }
  }

  initSlider() {
    this.isPaused = false;
    this.forcePaused = false;
    this.duration = parseInt(this.dataset.autorotateSpeed) || 5;
    this.interval = 10;
    this.percentTime = 0;
    this.progressStartTime = null;

    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.playButton = this.querySelector('button[name="play"]');

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onSliderPaused = this.onSliderPaused.bind(this);
    this.prevButton && this.prevButton.addEventListener('click', this.onButtonClick);
    this.nextButton && this.nextButton.addEventListener('click', this.onButtonClick);
    this.playButton && this.playButton.addEventListener('click', this.onButtonClick);
    this.addEventListener('slider:paused', this.onSliderPaused);

    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    if (this.dataset.autorotate === 'true' && this.autorotateEnabled) {
      this.startProgressbar();
    } else {
      this.setForcePaused(true);
    }

    clearTimeout(this.initTimeout);
    this.initTimeout = setTimeout(() => {
      const sliderEl = this.querySelector('.announcement-slider');
      if (!sliderEl) return;

      this.flickity = new Flickity(sliderEl, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        setGallerySize: false,
      });

      this.flickity.on('change', () => {
        if (
          !this.isPaused &&
          this.autorotateEnabled &&
          this.dataset.autorotate === 'true'
        ) {
          this.startProgressbar();
        }
      });
    });
  }

  removeListeners() {
    this.prevButton && this.prevButton.removeEventListener('click', this.onButtonClick);
    this.nextButton && this.nextButton.removeEventListener('click', this.onButtonClick);
    this.playButton && this.playButton.removeEventListener('click', this.onButtonClick);
    this.removeEventListener('slider:paused', this.onSliderPaused);
    clearTimeout(this.initTimeout);
  }

  onSliderPaused(event) {
    this.setAttribute('data-paused', event.detail.paused);
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.currentTarget;

    if (target.name === 'next') {
      this.flickity && this.flickity.next();
    } else if (target.name === 'previous') {
      this.flickity && this.flickity.previous();
    } else {
      this.setForcePaused(!this.forcePaused);

      if (!this.forcePaused && this.autorotateEnabled) {
        this.startProgressbar();
      }
    }
  }

  setForcePaused(paused) {
    this.forcePaused = paused;
    this.setPaused(paused);
  }

  setPaused(paused) {
    this.isPaused = paused;

    const event = new CustomEvent('slider:paused', {
      detail: { paused },
    });
    this.dispatchEvent(event);
  }

  resetProgressbar() {
    this.style.setProperty('--progress-width', '0%');
    clearInterval(this.tick);
    this.tick = null;
    this.progressStartTime = null;
  }

  startProgressbar() {
    if (this.dataset.autorotate !== 'true') return;

    this.resetProgressbar();
    this.percentTime = 0;
    this.progressStartTime = performance.now();
    this.tick = window.setInterval(this.increase.bind(this), this.interval);
  }

  increase() {
    if (this.isPaused || !this.autorotateEnabled || !this.progressStartTime) return;

    const elapsed = performance.now() - this.progressStartTime;
    this.percentTime = Math.min((elapsed / (this.duration * 1000)) * 100, 100);
    this.style.setProperty('--progress-width', `${this.percentTime}%`);

    if (this.percentTime >= 100) {
      this.flickity && this.flickity.next();
      this.startProgressbar();
    }
  }

  handleIntersection(entries, _observer) {
    if (entries[0].isIntersecting) {
      if (!this.forcePaused) {
        this.setPaused(false);

        if (
          this.dataset.autorotate === 'true' &&
          this.autorotateEnabled &&
          !this.tick
        ) {
          this.startProgressbar();
        }
      }
    } else {
      this.setPaused(true);
      this.resetProgressbar();
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar);